import { useQuery } from "@tanstack/react-query";
import React from "react";

import { CoachPublicProfileProvider } from "~/contexts/coach";
import { coachQueryOptions } from "~/lib/query-options";
import type { CoachPublicData } from "~/shared/loaders";

interface CoachLayoutProps {
  username: string;
  children: React.ReactNode;
  coach?: CoachPublicData; // Optional pre-loaded coach data
}

export function CoachLayout({
  username,
  children,
  coach: preloadedCoach,
}: CoachLayoutProps) {
  // Get coach data from React Query using centralized query options
  const { data: coach } = useQuery({
    ...coachQueryOptions.byUsername(username),
    initialData: preloadedCoach,
  });

  if (!coach) {
    return <div>Loading...</div>;
  }

  return (
    <CoachPublicProfileProvider coachProfile={coach}>
      {children}
    </CoachPublicProfileProvider>
  );
}
